<template>
  <div>
        <AppTop />
        <main>
          <TasksCalendar v-if="getBanners" 
            :tasks="getBanners"
            :platform="newItem.platform" 
            :count="10"
            @push="pushTask" 
            @duble="pushDouble">
          </TasksCalendar>

          <AddTask v-if="showModal" 
            @close="showModal = false" 
            name="RU" 
            :lang="lang" 
            mode="new" 
            :date="newItem.date" 
            :inputPosition="newItem.inputPosition" 
            :forbiddenDates="newItem.forbiddenDays" 
            :platform="newItem.platform" 
          />
          <AddTask v-if="showDouble" 
            @close="showDouble = false" 
            name="RU" 
            :lang="lang" 
            mode="double" 
            :forbiddenDates="newItem.forbiddenDays" 
            :platform="newItem.platform" 
            :task="doubleTask"
          />
          <EditTaskModal v-if="showEditModal" 
            @close="showEditModal = false" 
            :editTask="editTask" 
            :lang="lang" 
            :platform="newItem.platform" 
            :forbiddenDates="disabledDates"
          />

        </main>
    </div>
</template>

<script>
import AddTask from '@/components/modals/AddTaskModal.vue'
import EditTaskModal from '@/components/modals/EditTaskModal.vue'
import TasksCalendar from '@/components/TasksCalendar.vue'
import AppTop from '@/components/TopPage.vue'

import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      showModal: false,
      showDouble: false,
      showEditModal: false,
      disabledDates: {},

      editTask: '',
      doubleTask: '',
      lang: {
        first: 'RU',
        second: 'EN'
      },
      newItem: {
          date: null,
          inputPosition: null,
          forbiddenDays: null,
          platform: 2
      }
    }
  },
  components: {
    AddTask,
    EditTaskModal,
    TasksCalendar,
    AppTop
  },
  computed: {
      ...mapGetters(['getTasks', 'getBanners']),
  },
  methods: {
    ...mapActions(['fetchTasks']),
    pushTask: async function( id, forbiddenDates, isShow = true ) {
      await this.getBanners.forEach(el => {
        if ( el.id == id ) {
            this.showEditModal = isShow;
            this.editTask = el;
            this.disabledDates = forbiddenDates;
        }
      });
    },
    newModal(date, inputPosition, forbiddenDays) {

        this.newItem.date = date;
        this.newItem.inputPosition = inputPosition;
        this.newItem.forbiddenDays = forbiddenDays;
        this.showModal = true;
    },
    pushDouble(forbiddenDays) {
        const task = this.editTask;
        const doubleTask = {
            inputButtonLink: task.inputButtonLink,
            inputCountView: task.inputCountView,
            inputPosition: task.inputPosition,
            inputTextFirst: task.inputTextFirst,
            inputTitleFirst: task.inputTitleFirst,
            inputTxtBtnFirst: task.inputTxtBtnFirst,
            inputTextSecond: task.inputTextSecond,
            inputTitleSecond: task.inputTitleSecond,
            inputTxtBtnSecond: task.inputTxtBtnSecond,
            platformId: this.newItem.platform,
            tagName: task.tagName,
            vendorName: task.vendorName,
            visible: task.visible,
            backgroundSrc: task.backgroundSrc,
            backgroundSrcMobile: task.backgroundSrcMobile,
            dateSpace: [],
            images: task.images,
        }
        this.doubleTask = doubleTask;
        this.showDouble = true;
        this.newItem.forbiddenDays = forbiddenDays;
    },
  },
  async created() {
      await this.$store.dispatch('get_banners', {platform: 2});
  }

}
</script>
